import { classNames } from "../../ui/styles/classNames";

/** One `dmw-connector` command, the backup for people who use a terminal (F47, P-F). */
export default function CommandLine({ command, className }: { command: string; className?: string }) {
  return <code className={classNames("app-code-line block w-fit px-2 py-1 font-mono text-xs", className)}>{command}</code>;
}
